(() => {
  const initializeBlogArticle = () => {
    const content = document.querySelector('[data-blog-article-content]');
    const toc = document.querySelector('[data-blog-toc]');
    const list = document.querySelector('[data-blog-toc-list]');
    if (!content || !toc || !list) return;

    const headings = [...content.querySelectorAll('h2[id], h3[id]')];
    if (headings.length < 3) return;

    const fragment = document.createDocumentFragment();
    headings.forEach((heading) => {
      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'blog-toc__subitem';
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      fragment.append(item);
    });
    list.replaceChildren(fragment);
    toc.hidden = false;

    content.querySelectorAll('a[target="_blank"]').forEach((link) => {
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', [...rel].join(' '));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBlogArticle, { once: true });
  } else {
    initializeBlogArticle();
  }
})();
